import React, { useState } from 'react';
import { API_BASE } from '../../App';
import { toast } from 'react-toastify';

const SendNotification = ({ session }) => {
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSend = async (e) => {
        e.preventDefault();

        if (!title || !body) {
            toast.error('Title and Message are required');
            return;
        }

        if (!window.confirm('Are you sure you want to send this push notification to ALL users?')) {
            return;
        }

        setLoading(true);
        try {
            const token = session?.access_token || localStorage.getItem('admin_token');

            const response = await fetch(`${API_BASE}/admin/notifications/broadcast`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    title,
                    body,
                    url
                })
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to send notification');
            }

            const data = await response.json();
            toast.success(`Notification sent to ${data.recipientCount} users! 🚀`);

            // Reset form
            setTitle('');
            setBody('');
            setUrl('');
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h3 style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                📢 Send Broadcast Notification
            </h3>

            <div style={{
                background: 'var(--accent-bg)',
                padding: '15px',
                borderRadius: '8px',
                marginBottom: '20px',
                fontSize: '0.9rem',
                color: 'var(--text-secondary)'
            }}>
                ⚠️ This will send a web push notification to <strong>all subscribed users</strong>. Use with caution.
            </div>

            <form onSubmit={handleSend}>
                <div className="form-group">
                    <label className="form-label">Title</label>
                    <input
                        type="text"
                        className="form-input"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="e.g. Tournament Starting Soon!"
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Message</label>
                    <textarea
                        className="form-input"
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        placeholder="e.g. Join the room now. ID: 123456"
                        rows={4}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Link URL (Optional)</label>
                    <input
                        type="text"
                        className="form-input"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="e.g. /dashboard/matches"
                    />
                </div>

                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                    style={{ width: '100%', marginTop: '10px' }}
                >
                    {loading ? 'Sending...' : '🚀 Send to All Users'}
                </button>
            </form>
        </div>
    );
};

export default SendNotification;
